<template>
  <div class="promptPopups">
    <div class="promptPopups-main">
      <div class="promptPopups-main-title">温馨提示</div>
      <div class="promptPopups-main-text">
        <div class="promptPopups-con-title">
          <!-- 临近航线 -->
          <template v-if="hasNrpContent.type == 'timeOut'">
            <div style="margin-bottom: 5px;">
              <p>您预订的航线为<span class="activeText">{{ hasNrpContent.title }},</span>
                请仔细阅读以下内容并确认：
              </p>
            </div>
          </template>
          <template v-else>
            <!--          收费退订-->
            <div v-if="hasNrp && !hasRp" class="contentTitle">
              <p>您选择的是<span class="activeText">{{ hasNrpContent.title }},</span>
                取消需<span class="activeText">承担取消费用，</span>
              </p>
              <div class="contentTitle">
                请阅读退订政策并确认
              </div>
            </div>
            <!--          常规退订-->
            <div v-if="!hasNrp && hasRp" class="contentTitle">
              <span>您选择的是</span>
              <span class="activeText">{{ hasNrpContent.title }},</span>
              开航前第45天起
              <div class="contentTitle">
                取消<span class="activeText">需承担取消费用,</span>请阅读退订政策并确认
              </div>
            </div>
            <!--          收费常规都有-->
            <div v-if="hasNrp && hasRp" class="titleAll">
              您的预订同时包含<span class="activeText">收费退订</span>和<span class="activeText">常规退订</span>两种退订模式
              <div class="promptPopups-con-text">
                具体政策不同。请阅读退订政策并确认
              </div>
            </div>
          </template>

        </div>

        <template v-if="hasNrpContent.type == 'timeOut'">
          <div class="cancellation">
            <div>
              <div v-html="contentData"></div>
            </div>
          </div>
        </template>

        <template v-else>
          <div class="cancellation" v-if="hasNrp && !hasRp">
            <div>
              <span style="font-weight: bold">{{ hasNrpContent.titleText }}</span>
              <div v-html="cancelPolicyNrp"></div>
            </div>
          </div>
          <div class="cancellation" v-if="!hasNrp && hasRp">
            <div>
              <span style="font-weight: bold">{{ hasNrpContent.titleText }}</span>
              <div v-html="cancelPolicy">
              </div>
            </div>
          </div>
          <div class="cancellation-text" v-if="hasNrp && hasRp">
            <div style="margin-bottom: 10px">
              <span style="font-weight: bold">{{ hasNrpContent.titleText }}</span>
              <div v-html="cancelPolicy"></div>
            </div>
            <div>
              <span style="font-weight: bold">{{ hasNrpContent.titleText }}</span>
              <div v-html="cancelPolicyNrp">
              </div>
            </div>
          </div>
        </template>
        <div class="footer-btn">
          <div class="close-btn" @click="closePromptPopups">返回</div>
          <div class="callPromptBtn" @click="headCallPrompt">确认预订</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import nrpConfig from '@/utilities/nrpConfig'

export default {
  props: {
    hasNrp: {
      type: Boolean,
      default() {
        return false
      }
    },
    hasRp: {
      type: Boolean,
      default() {
        return false
      }
    },
    hasOutTime: {
      type: Boolean,
      default() {
        return false
      }
    },
    contentData: {
      type: String,
      default() {
        return ''
      }
    },
    cancelPolicy: {
      type: String,
      default() {
        return ''
      }
    },
    cancelPolicyNrp: {
      type: String,
      default() {
        return ''
      }
    }
  },
  data() {
    return {
      hasNrpContent: '',
    }
  },

  watch: {
    hasNrp: {
      handler() {
        // 延时展示
        setTimeout(() => {
          if (this.hasOutTime) {
            this.hasNrpContent = nrpConfig.outTime
            return
          }
          if (this.hasNrp) {
            this.hasNrpContent = nrpConfig.nrp
          }
          if (this.hasRp) {
            this.hasNrpContent = nrpConfig.rp
          }

          console.log(this.hasNrpContent, 'this.hasNrpContent')
        }, 20)
      },
      immediate: true
    },

  },
  computed: {},
  methods: {
    closePromptPopups() {
      this.$emit('closePromptPopups')
    },
    headCallPrompt() {
      this.$emit('headCallPrompt')
    },
  }
}
</script>
<style scoped lang="less">
.activeText {
  color: #f7be33;
}

.promptPopups {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 2001;
  background-color: rgba(0, 0, 0, 0.6);
  /* padding: 0 74rpx; */

  .promptPopups-main {
    width: 290px;
    background-color: #ffffff;
    box-shadow: 0 4px 40px 0 rgba(0, 0, 0, 0.1);
    //border-radius: 16px;
    box-sizing: border-box;
    position: relative;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 8px;
    overflow: hidden;
    padding: 0;

    .promptPopups-main-title {
      text-align: center;
      font-size: 20px;
      color: #f8c233;
      border-bottom: 1px solid #f3f3f3;
      margin: 0 12px;
      line-height: 40px;
    }

    .countdown {
      position: absolute;
      right: 10px;
      top: 15px;
      font-size: 15px;
      color: #717171;
    }

    .promptPopups-main-text {
      text-align: center;
      margin: 11px 0 50px;
      padding: 0 13px;

      .promptPopups-con-title {
        font-size: 10px;
        
        color: #060606;
        line-height: 18px;

        p {
          margin: 0;
        }

        .contentTitle {
          font-size: 12px;
          margin-bottom: 8px;
        }

        .titleAll {
          font-size: 10px;
        }
      }

      .promptPopups-con-text {
        font-size: 10px;
        
        color: #060606;
        line-height: 18px;
        margin-bottom: 10px;
      }

      .text-con {
        color: #f2ba32;
      }

      .footer-btn {
        width: 100%;
        position: absolute;
        height: 40px;
        left: 0;
        bottom: 0;
        display: flex;

        .close-btn {
          width: 50%;
          
          font-weight: 600;
          color: #171717;
          line-height: 40px;
          height: 40px;
          text-align: center;
          cursor: pointer;
          font-size: 15px;
          background-color: rgba(234, 234, 234, 1);
        }

        .callPromptBtn {
          width: 50%;
          font-size: 15px;
          
          font-weight: 600;
          color: #171717;
          line-height: 40px;
          height: 40px;
          text-align: center;
          cursor: pointer;
          background: linear-gradient(-90deg, #ffd500 0%, #ffbf00 100%);
        }
      }

      .cancellation-text {
        background: #f3f3f3;
        padding: 7px;
        text-align: left;
        overflow: auto;
        color: #060606;
        font-size: 9px;
        max-height: 165px;
      }

      .cancellation {
        background: #f3f3f3;
        padding: 7px;
        text-align: left;
        overflow: auto;
        color: #060606;
        font-size: 9px;
        max-height: 165px;
      }
    }
  }
}
</style>
<style lang="less">
.cancellation-text p {
  color: #060606 !important;
  font-size: 9px !important;
  margin: 0 !important;
  line-height: 14px !important;

  span {
    color: #060606 !important;
    font-size: 9px;
  }
}

.cancellation P {
  text-align: left;
  color: #060606 !important;
  font-size: 10px !important;
  margin: 0 !important;
  line-height: 14px !important;
  position: relative !important;

  span {
    color: #060606 !important;
    font-size: 9px;
  }
  .red{
    color: red !important;
    font-size: 10px !important;
  }
}

.cancellation-text .bubbleInfoCon,
.cancellation .bubbleInfoCon {
  // margin-top: 13px;
}

.cancellation-text .lineTitle,
.cancellation .lineTitle {
  display: none;
}

#pointInPopup{
  position: relative;
  padding-left: 10px;
  box-sizing: border-box;
  &::after{
    content: '';
    position: absolute;
    left: 0;
    top: 5px;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: #060606;
  }
}
</style>